// extracted by mini-css-extract-plugin
module.exports = {"table":"WebhooksTable_table__1HZKk","header":"WebhooksTable_header__xz32M"};